import type {TuiLanguageCore} from '@taiga-ui/i18n/types';

import {TUI_ENGLISH_LANGUAGE_COUNTRIES} from './countries';

export const TUI_ENGLISH_LANGUAGE_CORE: TuiLanguageCore = {
    months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ],
    close: 'Close',
    clear: 'Clear',
    nothingFoundMessage: 'Nothing found',
    defaultErrorMessage: 'Value is invalid',
    spinTexts: ['Previous', 'Next'],
    shortWeekDays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    countries: TUI_ENGLISH_LANGUAGE_COUNTRIES,
};
